import { useState } from "react";

export default function HistoryCalendar({ history }) {
    const [currentDate, setCurrentDate] = useState(new Date());

    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();

    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDayIndex = new Date(year, month, 1).getDay();

    const prevMonth = () => setCurrentDate(new Date(year, month - 1, 1));
    const nextMonth = () => setCurrentDate(new Date(year, month + 1, 1));

    // Format date like "08/10/25"
    const formatDate = (day) =>
        `${String(day).padStart(2, "0")}/${String(month + 1).padStart(2, "0")}/${String(
        year
        ).slice(2)}`;

    // Filter history by current month and year
    const filteredHistory = history.filter((entry) => {
        const [day, m, yRaw] = entry.date.split("/");
        const y = Number(yRaw.split(" ")[0].slice(-2));
        return m == month + 1 && y === Number(String(year).slice(2));
    });


    // Build an array for all days in the month
    const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    return (
        <div className="calendar-container">
            <div className="calendar-header">
            <button className="calendar-btn_prev" onClick={prevMonth}>▶</button>
            <h2 className="calendar-title">
                {currentDate.toLocaleString("default", { month: "long" })} {year}
            </h2>
            <button className="calendar-btn_next" onClick={nextMonth}>◀</button>
            </div>

            <div className="calendar-grid">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                <div key={day} className="calendar-day-header">{day}</div>
            ))}

            {/* Empty cells before the first day */}
            {Array.from({ length: firstDayIndex }).map((_, i) => (
                <div key={`empty-${i}`} className="calendar-day empty"></div>
            ))}

            {/* Days */}
            {daysArray.map((day) => {
                const dateStr = formatDate(day); // "08/10/25"
                const dayData = filteredHistory.find((entry) =>
                    entry.date.startsWith(dateStr) // since your date includes time
                );

                return (
                <div key={day} className={`calendar-day ${dayData ? "active" : ""}`}>
                    <div className="calendar-day-number">{day}</div>
                    {dayData && (
                    <div className="calendar-day-content">
                        {dayData.data.map((task) => (
                        <p
                            key={task.id}
                            className={`calendar-task ${
                            task.status ? "task-pending" : "task-done"
                            }`}
                        >
                            {task.content}
                        </p>
                        ))}
                    </div>
                    )}
                </div>
                );
            })}
            </div>
        </div>
        );

}
